// src/components/HashtagNewsList.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// ⚠ make sure path/case matches your file: "../API" vs "../api"
import { fetchHashtagNews } from "../api";
import NewsCard from "./NewsCard";

const HashtagNewsList = () => {
  const { tagValue } = useParams(); // from /hashtag/:tagValue
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        setErr(null);

        const data = await fetchHashtagNews(tagValue);
        console.log("Hashtag news data:", data);

        if (!cancelled) {
          // data.stories is the array we care about
          setItems(Array.isArray(data.stories) ? data.stories : []);
          if (!data.stories || data.stories.length === 0) {
            setErr("या हॅशटॅगसाठी बातम्या उपलब्ध नाहीत.");
          }
        }
      } catch (e) {
        console.error("Error loading hashtag news", e);
        if (!cancelled) {
          setErr("या हॅशटॅगसाठी बातम्या उपलब्ध नाहीत.");
          setItems([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tagValue]);

  if (loading) {
    return <div className="loading">बातम्या लोड होत आहेत...</div>;
  }

  if (err) {
    return <div className="error-message">{err}</div>;
  }

  return (
    <section>
      {/* Heading on top */}
      <h2 style={{ fontSize: 18, margin: "4px 4px 10px" }}>
        #{decodeURIComponent(tagValue)}
      </h2>

      <div className="news-list">
        {items.map((item, idx) => (
          <NewsCard
            key={item.uniq_link || idx}
            item={item}
            index={idx}
            category={`hashtag-${tagValue}`}
            relatedStories={items.filter(
              (x) => x.uniq_link !== item.uniq_link
            )}
          />
        ))}
      </div>
    </section>
  );
};

export default HashtagNewsList;
